<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="900px">
      <v-card>
        <v-toolbar class="headline" color="primary" dark>{{ title }}</v-toolbar>
        <v-card-text>
          <v-form ref="p1DialogForm" v-model="valid" lazy-validation>
            <v-container>
              <v-col cols="4">
                <ryou-input label="物件名" v-model="model.building_name" :value="model.building_name" :maxlength="15" :disabled="true">
                </ryou-input>
              </v-col>
              <v-row>
                <div class=attention>課金額は税込み金額を入力してください</div>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <ryou-input v-model="model.billing_name" :value="model.billing_name" :label="'課金区分'" :rules="inputNameRules" :maxlength="32"></ryou-input>
                </v-col>
                <v-col cols="6">
                  
                  <ryou-input v-model="model.billing_fee" :value="model.billing_fee" prepend-icon="mdi-currency-cny" :label="'課金額'" :rules="inputCostRules" :maxlength="5"></ryou-input>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <ryou-black-btn :label="'閉じる'" :handlerClick="handleCancel" :iconCls="'mdi-close'"></ryou-black-btn>
          <v-spacer></v-spacer>
          <ryou-black-btn :label="'登録'" :handlerClick="handleOkConfirm"></ryou-black-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
        <ryou-confirm ref="confirm"></ryou-confirm>
      </v-card>
      </v-dialog>
    </v-row>
  </template>

  <script>
    import RyouInput from "@/components/formInput/RyouInput.vue";
    import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";
    import RyouConfirm from "@/components/dialog/RyouConfirm.vue";

    export default {
      name: "MasterOtherCostDialog",
      components: {
        RyouInput,
        RyouBlackBtn,
        RyouConfirm,
      },
      mounted() {
        this.inputNameRules.push(this.GlobalRules.required);
        this.inputCostRules.push(this.GlobalRules.required);
        this.inputCostRules.push(this.GlobalRules.number);
      },
      props: {
        url: {
          type: Object,
          required: true,
          default: () => { }
        }
      },
      data: () => ({
        dialog: false,
        title: "",
        valid: true,
        inputNameRules: [],
        inputCostRules: [],
        buildingName: "",
        billing_seq_no: null,
        model: {
          building_id: 0,
          billing_fee: "",
          billing_name: "",
          building_name: "",
          billing_seq_no: null,
        },
      }),

      created() {
      },

      watch: {
      },

      methods: {
        add(selectBuildName) {
          this.open();
          this.title = "その他課金入力マスタ";
          setTimeout(() => {
            this.model.building_name = selectBuildName.building_name
            this.model.building_id = selectBuildName.building_id
          }, 10);
        },

        edit(record) {
          this.open();
          this.title = "その他課金入力マスタ編集";
          setTimeout(() => {
            this.model = Object.assign({}, record);
          }, 10);
        },

        handleOk() {
          var valid = this.$refs.p1DialogForm.validate();
          if (valid) {
            var that = this;
            
            let params = {};

            if (this.model.billing_seq_no) {//更新処理
                params["building_id"] = this.model.building_id
                params["user_id"] = this.$store.getters.getUserId
                params["billing_seq_no"] =  this.model.billing_seq_no
                params["billing_name"] = this.model.billing_name
                params["billing_fee"] = this.model.billing_fee
            } else {//追加処理
                params["building_id"] = this.model.building_id
                params["user_id"] = this.$store.getters.getUserId
                params["billing_name"] = this.model.billing_name
                params["billing_fee"] = this.model.billing_fee
                params["billing_seq_no"] = null
            }
                this.postRequest(this.url.update, params, this.$store.getters.getUserToken).then(resp => {

                if (resp.success) {
                  that.$emit("ok");
                  }
                  this.model.billing_seq_no = null
                that.close();
              });
            }
          },

        //確認ダイアログ
        handleOkConfirm() {
          var valid = this.$refs.p1DialogForm.validate();
          if (valid) {
            this.$refs.confirm.open("登録", "登録します。宜しいですか？", { color: "info" }).then((confirm) => {
              if (confirm) {
                this.handleOk();
              }
            });
          }
        },

        handleCancel() {
          this.model.billing_seq_no = null
          this.close();
        },
        close() {
          this.dialog = false;
        },
        open() {
          this.dialog = true;
          if (this.$refs.p1DialogForm) {
            this.$refs.p1DialogForm.reset();
            this.$refs.p1DialogForm.resetValidation();
          }
        }
      }
    };
  </script>

  <style>
    .attention {
      font-size: 18px;
      width: 763px;
      text-align: right;
      color: red;
    }
  </style>
